<template>
  <div>
    <div class="page-container">
      <el-button plain @click="back">返回</el-button>
      <div class="titie">我的使用情况</div>
      <Form :dialogFormVisible="dialogFormVisible" @controlFormWindow="controlFormWindow"  :storageNum = "storageNum"/>
        <Table :headerData="headerData" :tableData="tableData" :tableText="tableText" :tableCount="tableCount " :border="true" @changeTable="changeTable">
          <el-table-column
          fixed="right"
          label="操作"
          width="130"
          align="center">
          <template slot-scope="scope">
              <el-button  type="text" size="small" @click="addParameter(scope.row)" >增加</el-button>
              <el-button @click="checkDetail(scope.row)" type="text" size="small">查看</el-button>
          </template>
          </el-table-column>
        </Table>
      </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Table from 'components/Table'
import Form from './Form'
import { Header } from './TableHeaderData.js'
import useCondition from 'api/Management/useCondition.js'
const _useCondition = new useCondition()
export default {
  data() {
    return {
        key:'',
        per_page:10,
        page:1,
        dialogFormVisible: false,
        storageNum:'',
        // 表单必须数据
        headerData: Header,
        tableData: [], // 表格数据
        tableText: '加载中',
        tableCount: 0,
        selectedStr: '', // 选择的表格选择字符串
        currentPage: 1, // 当前页
        currentPageLength: 10, // 当前页长度
    }
  },
    mounted(){
        this.getUseMessageList()
    },
    methods:{
        back() {
            this.$router.back()
        },
        getUseMessageList(){
            this.tableData = []
            this.tableText = '加载中'
            if (this.$route.params.chemID && this.$route.params.USER_ID){
                _useCondition.getMyUserList(this.per_page,this.page,this.$route.params.chemID,this.$route.params.USER_ID).then(res => {
                    this.tableData = res.items
                    this.tableCount = res._meta.totalCount
                    if(res.items.length === 0 ) {
                        this.tableText = '暂无数据'
                    }
                })
            }

        },
        // 改变页数/页长度
        changeTable({currentPage, pageLength}) {
            this.tableData = []
            // 临时存储当前页/当前页长度
            this.currentPage = currentPage
            this.currentPageLength = pageLength
            this.per_page = pageLength
            this.getUseMessageList()
        },
        // 查看
        checkDetail(row) {
            this.$router.push({path: `/cs/parameterInformation/detail/${row.STORAGE_NO}`})
        },
        controlFormWindow(flag) {
            this.dialogFormVisible = flag
            this.getUseMessageList()
        },
        // 增加弹窗
        addParameter(row){
            if(row.CURRENT_VOLUME >0) {
                this.currentData = {}
                this.dialogFormVisible = true
                this.storageNum = row.STORAGE_NO
            }else {
                this.$message({
                    message: '余量为0！不能增加',
                    type: 'warning'
                })
            }

        },

    },
  components: {
      Table,
      Form
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .titie {
    width 100%
    height 30px
    line-height 30px
    font-size:16px;
    font-family:SimSun;
    font-weight:bold;
    color:rgba(62,62,62,1)
    text-align center
  }
</style>

